import { render, staticRenderFns } from "./WithdrawSidebar.vue?vue&type=template&id=bde428cc"
import script from "./WithdrawSidebar.vue?vue&type=script&lang=js"
export * from "./WithdrawSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports